import React from 'react';
import History from '../components/History';
import CoreValues from '../components/CoreValues';
import Faculty from '../components/Faculty';
import Footer from '../components/Footer';
import '../css/AboutUs.css';

const AboutUs = () => {
    return (
        <div className='about-us-container'>
           <History/>
           <CoreValues/>
           <Faculty/>
           <Footer/>
        </div>
    );
};

export default AboutUs;
